/** Mẫu chuẩn Minh Tiến: HỢP ĐỒNG KINH TẾ (mua bán hàng hóa) – bản rút gọn. Bên A = Minh Tiến (bán), Bên B = khách (mua). */
// 04/11/2026 anh Tiến: "Hợp đồng đơn giản nhất có thể" → rút từ 12 điều + phụ lục (file Word MINH_TIEN_HOP_DONG_KINH_TE_BAN_NANG_CAP.docx, 09/10/2026)
// còn 5 điều; thông tin ERP có thì tự điền, không để ô chấm trống (chỉ chừa đại diện / chức vụ Bên B để khách ghi khi ký).
// Đơn giá ERP luôn chưa VAT (DEC-005). Hợp đồng lập trước ngày đổi giữ nguyên điều khoản cũ (lưu theo từng hợp đồng).
import type { StdContractTemplate } from './contract-doc';

export const STD_ECONOMIC: StdContractTemplate = {
  type: 'std_economic',
  footerText: "MINH TIẾN – HỢP ĐỒNG KINH TẾ",
  headerText: "CÔNG TY TNHH XNK THÉP & THIẾT BỊ CÔNG NGHIỆP MINH TIẾN",
  partyLetters: {'buyer': 'B', 'seller': 'A'},
  basis: `Căn cứ Bộ luật Dân sự số 91/2015/QH13, Luật Thương mại số 36/2005/QH11 và thỏa thuận của hai bên.`,
  head: `::table widths=50,50 border=none
| **CÔNG TY TNHH XNK THÉP & TBCN MINH TIẾN**<br>**Số: {Số hợp đồng|……}** | **CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM**<br>**Độc lập – Tự do – Hạnh phúc** |

^^ HỢP ĐỒNG KINH TẾ
^ __(Mua bán hàng hóa)__
{Căn cứ pháp lý}
Hôm nay, {Ngày ký bằng chữ|ngày …… tháng …… năm ……} tại {Nơi ký|Tp. Hồ Chí Minh}, chúng tôi gồm:
# BÊN A – BÊN BÁN
CÔNG TY TNHH XUẤT NHẬP KHẨU THÉP & THIẾT BỊ CÔNG NGHIỆP MINH TIẾN
Địa chỉ: 1097 Huỳnh Văn Lũy, Phường Bình Dương, Thành phố Hồ Chí Minh, Việt Nam
Điện thoại: 0937.664.114     Mã số thuế: 3702761360
Đại diện: Ông DƯƠNG VĂN TIẾN – Chức vụ: Giám đốc
Tài khoản Vietcombank: 1071000572169 – Chi nhánh Đông Bình Dương
Tài khoản Eximbank: 180080700000058 – Chi nhánh Bình Dương
# BÊN B – BÊN MUA
{Tên bên mua|…………………………………………}
Địa chỉ: {Địa chỉ bên mua|…………………………………………}
Mã số thuế: {MST bên mua|}     Điện thoại: {Điện thoại bên mua|}     Email: {Email bên mua|}
Đại diện: {Đại diện bên mua|…………………………}  Chức vụ: {Chức vụ bên mua|………………}
**Hai bên thống nhất mua bán hàng hóa với các điều khoản sau:**`,
  articles: [
    {
      title: "ĐIỀU 1. HÀNG HÓA VÀ GIÁ TRỊ",
      body: `1.1. Bên A bán, Bên B mua hàng hóa theo đơn hàng số {Số đơn hàng} như bảng dưới. Hàng mới, đúng tên, quy cách ghi trong bảng.
[BẢNG HÀNG HÓA]
1.2. Tiền hàng: {Tổng tiền hàng} VNĐ; thuế GTGT {Thuế suất GTGT}%: {Tiền thuế GTGT} VNĐ. **Tổng giá trị thanh toán: {Tổng giá trị} VNĐ** (bằng chữ: {Tổng giá trị bằng chữ}).
1.3. Đơn giá chưa gồm thuế GTGT, cố định cho đơn hàng này. Tiền hàng tính theo số lượng thực giao ghi trên biên bản giao nhận.`,
    },
    {
      title: "ĐIỀU 2. THANH TOÁN",
      body: `2.1. {Thanh toán}
2.2. Chuyển khoản vào một trong hai tài khoản của Bên A ghi ở trên. Bên A xuất hóa đơn GTGT theo hàng thực giao.
2.3. Chậm thanh toán thì Bên B trả thêm lãi trên số tiền chậm trả theo quy định của pháp luật; Bên A được tạm ngừng giao phần hàng còn lại đến khi Bên B thanh toán.`,
    },
    {
      title: "ĐIỀU 3. GIAO NHẬN HÀNG",
      body: `3.1. Địa điểm giao: {Địa điểm giao hàng}. Thời gian giao: {Thời gian giao hàng}.
3.2. Bên B cử người nhận, kiểm số lượng, quy cách khi nhận và ký biên bản giao nhận; sai lệch ghi ngay trên biên bản. Hàng đã ký nhận thì rủi ro chuyển sang Bên B.
3.3. Lỗi chất lượng không thấy được khi nhận: Bên B báo bằng văn bản ngay khi phát hiện, kèm hình ảnh, giữ nguyên hàng để Bên A kiểm tra. Lỗi do Bên A thì Bên A đổi hàng, bổ sung hoặc giảm giá phần hàng lỗi.`,
    },
    {
      title: "ĐIỀU 4. TRÁCH NHIỆM VÀ TRANH CHẤP",
      body: `4.1. Bên vi phạm hợp đồng bồi thường thiệt hại thực tế, có chứng từ cho bên kia. Trường hợp bất khả kháng theo pháp luật, bên bị ảnh hưởng báo ngay cho bên kia và không bị xem là vi phạm.
4.2. Tranh chấp được thương lượng trước; không thương lượng được thì đưa ra Tòa án nhân dân có thẩm quyền giải quyết.`,
    },
    {
      title: "ĐIỀU 5. HIỆU LỰC",
      body: `Hợp đồng có hiệu lực từ ngày ký đến khi hai bên hoàn thành nghĩa vụ. Sửa đổi, bổ sung phải lập bằng văn bản có xác nhận của hai bên. Hợp đồng lập thành 02 bản, mỗi bên giữ 01 bản, hoặc ký điện tử.`,
    },
  ],
  tail: `::table widths=50,50 border=none
| **ĐẠI DIỆN BÊN B – BÊN MUA**<br>[CHỮ KÝ KHÁCH]<br>**(Ký, ghi rõ họ tên, đóng dấu nếu có)**<br>**{Người ký bên mua|}** | **ĐẠI DIỆN BÊN A – BÊN BÁN**<br><br><br>**ÔNG DƯƠNG VĂN TIẾN**<br>**Giám đốc** |`,
  internal: `# PHỤ LỤC 2 – CHECKLIST KIỂM SOÁT TRƯỚC KHI KÝ (NỘI BỘ)
Không gửi phụ lục này cho khách hàng nếu không cần thiết. Nhân viên phụ trách phải kiểm tra và lưu hồ sơ.
☐ Xác minh pháp nhân, mã số thuế, địa chỉ, người đại diện/ủy quyền và thông tin liên hệ của khách hàng.
☐ Đã kiểm tra hạn mức công nợ, nợ quá hạn hiện tại và phê duyệt tín dụng nếu có bán chịu.
☐ Mã hàng, quy cách, tiêu chuẩn, độ dày/kích thước, dung sai, xuất xứ (nếu cam kết), đơn vị tính và số lượng đã rõ.
☐ Đã xác định cách tính tiền: cân thực tế/khối lượng lý thuyết/số lượng đếm; thống nhất dung sai nếu có.
☐ Giá, VAT, vận chuyển, bốc xếp, cẩu hạ, lưu kho và chi phí khác đã rõ; tổng tiền bằng số và bằng chữ khớp nhau.
☐ Lịch thanh toán ghi đủ điều kiện, số tiền/tỷ lệ, hạn thanh toán; tổng tỷ lệ bằng 100%; không để trống điều kiện công nợ.
☐ Đã xác định địa điểm, ngày/giờ giao, người nhận, điều kiện xe vào công trình và cách ký nhận.
☐ Đã chọn thời điểm chuyển rủi ro và quyền sở hữu; kiểm tra tính phù hợp với loại giao dịch.
☐ Chứng từ cần giao, thời hạn khiếu nại và điều kiện bảo hành đã ghi cụ thể.
☐ Điều khoản lãi chậm trả/phạt vi phạm không trái pháp luật áp dụng; không có điều khoản tự ý tịch thu tài sản.
☐ Đã xác định email/tài khoản được phép xác nhận đơn hàng và quy trình xác minh thay đổi tài khoản ngân hàng.
☐ Hàng đặt riêng/cắt theo quy cách/nhập riêng đã có điều kiện hủy đơn và xử lý chi phí thực tế.
☐ Lưu bản hợp đồng, phụ lục, báo giá, đơn đặt hàng, bằng chứng xác nhận, phiếu giao hàng, hóa đơn và đối chiếu công nợ.
# HƯỚNG DẪN DÙNG MẪU
1. Đây là mẫu hợp đồng mua bán/cung cấp hàng hóa, không dùng thay hợp đồng thi công/lắp đặt hoặc hợp đồng xây dựng chuyên ngành.
2. Với khách hàng trả trước: ghi rõ tiền tạm ứng và điều kiện trước khi xuất kho. Với khách hàng công nợ: chỉ điền hạn mức/thời hạn sau khi được phê duyệt nội bộ.
3. Với đơn hàng nhỏ/lặp lại, có thể dùng hợp đồng khung và từng đơn đặt hàng đã xác nhận; cần quy định rõ tài liệu nào ưu tiên khi có khác biệt.
4. Không ký khi còn trống giá, VAT, cách tính khối lượng, lịch thanh toán, địa điểm giao hoặc các điều kiện đặc biệt của đơn hàng.
5. Mẫu được thiết kế để giảm rủi ro vận hành; hợp đồng giá trị lớn, hàng nhập/đặt riêng, khách nợ dài hạn hoặc giao dịch có yếu tố xây dựng cần được rà soát theo tình huống cụ thể.`,
};
